import React from 'react';

import "./ProjectCard.css"

const ProjectCard = ({name, desc, img, onClick}) => {
    return (
        <div class="card" style={{backgroundImage: "url(" + img + ")"}} onClick={onClick}>
            <div class="card-content">
                <h3 class="card-title">{name}</h3>
                <p class="card-body">{desc}</p>
                <span class="card-cta">Click to learn more</span>
            </div>
        </div>
    )
}

export default ProjectCard;